import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Car,
  ChartLine,
  Users,
  FileText,
  Money,
  Bank,
  Warning,
  SignOut,
  Gauge,
  CaretRight,
  FileXls,
  Gear,
  Wrench,
  ChartBar,
  FolderOpen
} from '@phosphor-icons/react';

const Sidebar = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const allMenuItems = [
    { path: '/dashboard', icon: Gauge, label: 'Dashboard' },
    { path: '/clients', icon: Users, label: 'Clientes' },
    { path: '/vehicles', icon: Car, label: 'Vehículos' },
    { path: '/contracts', icon: FileText, label: 'Contratos' },
    { path: '/payments', icon: Money, label: 'Pagos' },
    { path: '/creditors', icon: Bank, label: 'Acreedores' },
    { path: '/expenses', icon: Wrench, label: 'Egresos' },
    { path: '/profitability', icon: ChartBar, label: 'Rentabilidad' },
    { path: '/alerts', icon: Warning, label: 'Alertas' },
    { path: '/reports', icon: FileXls, label: 'Reportes' },
    { path: '/documents', icon: FolderOpen, label: 'Documentos' },
    ...(isAdmin ? [{ path: '/settings', icon: Gear, label: 'Configuración' }] : []),
  ];

  const ROLE_MENUS = {
    contabilidad: ['/payments', '/expenses'],
    cobranza: ['/payments', '/alerts'],
    egresos: ['/expenses', '/documents'],
    solo_lectura: ['/dashboard', '/clients', '/vehicles', '/contracts', '/payments', '/creditors', '/expenses', '/profitability', '/alerts', '/reports'],
  };

  const menuItems = ROLE_MENUS[user?.role]
    ? allMenuItems.filter(item => ROLE_MENUS[user.role].includes(item.path))
    : allMenuItems;

  return (
    <div className="sidebar flex flex-col" data-testid="sidebar">
      {/* Logo */}
      <div className="p-6 border-b border-[#E2E8F0]">
        <div className="flex items-center gap-3">
          <img src="/lucars-logo.png" alt="LUCARS" className="h-10 w-auto" />
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4">
        <div className="px-4 mb-2">
          <span className="text-xs font-semibold text-[#64748B] uppercase tracking-wider">
            Menú Principal
          </span>
        </div>
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? 'active' : ''}`
            }
            data-testid={`nav-${item.path.replace('/', '')}`}
          >
            <item.icon size={20} weight={item.path === '/dashboard' ? 'fill' : 'regular'} />
            <span>{item.label}</span>
            <CaretRight size={16} className="ml-auto opacity-0 group-hover:opacity-100" />
          </NavLink>
        ))}
      </nav>

      {/* User info and logout */}
      <div className="p-4 border-t border-[#E2E8F0]">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-[#EFF6FF] rounded-full flex items-center justify-center">
            <span className="text-[#0055FF] font-semibold">
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-[#0F172A] truncate">{user?.name}</p>
            <p className="text-xs text-[#64748B] capitalize">{user?.role?.replace('_', ' ')}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm text-[#64748B] hover:text-[#E11D48] hover:bg-red-50 rounded-lg transition-colors"
          data-testid="logout-button"
        >
          <SignOut size={18} />
          Cerrar Sesión
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
